import * as angular from 'angular';
import * as _ from "lodash";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import GobWeightsServiceName, {GobWeightsService} from "../../services/measures/gobWeights.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import DeleteGobWeightName, {openDeleteGobWeight} from "./deleteGobWeight.controller";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import DateUtilityService from "../../services/utility/dateutility.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import {apsCommands} from "../../shared/dto/aps.commands";
import template from './gobWeightDetail.tpl.html';

let requires = [DeleteGobWeightName, GobWeightsServiceName, AuthDataServiceName, LoaderServiceName, NotifyServiceName, NewGuidServiceName];

export interface GobWeightDetailParams {
  plantId: string;
  shop: apsViewModels.ShopConfiguration;
  weight: apsViewModels.GobWeightItem;
  user: apsViewModels.UserData;
}

export interface GobWeightDetailResults {
  commentsAdded: boolean,
  gobWeightDeleted: boolean
}

export function openGobWeightDetail(data: GobWeightDetailParams,
                                    $modal: mm.foundation.modal): angular.IPromise<GobWeightDetailResults> {
  return $modal.open({
    template: template,
    controller: 'GobWeightDetailCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

class GobWeightDetailCtrl {
  private gobWeightsService: GobWeightsService;
  private loaderService: LoaderService;
  private notifyService: NotifyService;
  private authDataService: AuthDataService;
  private newGuidService: NewGuidService;
  private $modalInstance: mm.foundation.modalInstance;
  private $modal: mm.foundation.modal;
  private currentUser: apsViewModels.UserData;
  private commentsAdded: boolean = false;


  commentForm: angular.IFormController;
  plantId: string;
  shop: apsViewModels.ShopConfiguration;
  weight: apsViewModels.GobWeightItem;
  commentText: string = '';
  canDeleteWeight : boolean = false;  

  constructor(data: GobWeightDetailParams,
              $modalInstance: mm.foundation.modalInstance,
              $modal: mm.foundation.modal,
              gobWeightsService: GobWeightsService,
              newGuidService: NewGuidService,
              loaderService: LoaderService,
              authDataService: AuthDataService,
              notifyService: NotifyService) {
    this.weight = data.weight;
    this.plantId = data.plantId;
    this.shop = data.shop;
    this.$modalInstance = $modalInstance;
    this.$modal = $modal;
    this.loaderService = loaderService;
    this.gobWeightsService = gobWeightsService;
    this.notifyService = notifyService;
    this.newGuidService = newGuidService;
    this.authDataService = authDataService;
    this.currentUser = data.user;
    this.canDeleteWeight = false;
    
    if (authDataService.canDeleteWeights()) {
      this.canDeleteWeight = true;
    }
  }

  ok() {
    this.$modalInstance.close(this.commentsAdded);
  }

  addWeightComment() {
    if (this.commentForm.$invalid) {
      return;
    }

    let weightComment: apsCommands.AddGobWeightComment = {
      shopId: this.shop.id,
      comment: this.commentText,
      gob: this.weight.gob,
      isMachineId: this.weight.isMachineId,
      timeWeighed: this.weight.timeWeighed,
      createdOn: new Date()
    };

    let promise = this.gobWeightsService.addWeightComment(weightComment).then(() => {
      this.handleAddGobWeightComments(weightComment);
      this.commentsAdded = true;
      this.commentText = '';
      this.commentForm.$setPristine();
    }, this.notifyService.handleApiErrors);

    this.loaderService.loadingPromise(promise);
  }

  getPlantTime(time) {
    return DateUtilityService.formatTime(time, this.shop.timeZoneId);
  }

  handleAddGobWeightComments(cmd: apsCommands.AddGobWeightComment) {
    if (!_.some(this.weight.comments, (c => c.createdOn.getTime() === cmd.createdOn.getTime()))) {
      this.weight.comments.push({
        comment: cmd.comment,
        createdOn: cmd.createdOn,
        createdByFullName: this.currentUser.fullName
      });
    }
  }

  deleteGobWeight = () => {
    let result = openDeleteGobWeight(this.$modal);

    result.then(reason => {
      if (!reason) {
        return;
      }
      let deleteWeight: apsCommands.DeleteGobWeight = {
        shopId: this.shop.id,
        gob: this.weight.gob,
        isMachineId: this.weight.isMachineId,
        timeWeighed: this.weight.timeWeighed,
        comment: reason
      };
      let results: GobWeightDetailResults = {
        commentsAdded: true,
        gobWeightDeleted: true
      };

      let promise = this.gobWeightsService.deleteGobWeight(deleteWeight)
        .then( () => this.$modalInstance.close(results)
        , this.notifyService.handleApiErrors);
      this.loaderService.loadingPromise(promise);
      }
    );    
  };
}

export default angular.module('aps.controller.gobWeightDetail', requires)
  .controller('GobWeightDetailCtrl', GobWeightDetailCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/dashboard/gobWeightDetail.controller.ts